export default __webpack_public_path__ + "static/media/1.54126b67.jpg";